;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "UM4ZPbnFX6"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  var _ = $(this);
  var $formWraper = _.find('.lh-form');
  var $form       = _.find('form');
  if(section.settings.use_type == 'yes'){
    _.find('.lh-input').focus(function(){
      $formWraper.addClass('lh-focus');
    });
    $formWraper.click(function(e){
      var target = $(e.target);
      if(!target.closest('form').length){
        $formWraper.removeClass('lh-focus lh-show-type')
      }
    });
    _.find('.lh-icon-drop').click(function(){
      $formWraper.toggleClass('lh-show-type');
    })
  }
  _.find('.lh-input-icon').click(function(){
    $form.submit();
  })
  $form.submit(function(e){
    if(window.LAYOUTHUB_LIVE){
      e.preventDefault();
    }
  })
 };						cb.bind($('section[data-section-id="UM4ZPbnFX6"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="UM4ZPbnFX6"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/ZmHEruNeFAW5Gfd8/search/",						settings: {"use_type":"yes"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "74tVAyg9iN"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="74tVAyg9iN"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="74tVAyg9iN"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/ZmHEruNeFAW5Gfd8/faq-1/",						settings: {"style":"1"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "tkroxxqmf4q"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="tkroxxqmf4q"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="tkroxxqmf4q"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/ZmHEruNeFAW5Gfd8/faq-1/",						settings: {"style":"1"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "z1kn6k1611l"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="z1kn6k1611l"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="z1kn6k1611l"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/ZmHEruNeFAW5Gfd8/faq-1/",						settings: {"style":"1"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "wjiogv1565"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="wjiogv1565"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="wjiogv1565"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/ZmHEruNeFAW5Gfd8/faq-1/",						settings: {"style":"1"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "9o1hHqeKIW"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="9o1hHqeKIW"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/ZmHEruNeFAW5Gfd8/call-to-action/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');window.addEventListener("load",()=>{let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 15px","width: 100%","text-align: center","opacity: 1","z-index: 10000000000000000","text-indent: 0","color: #333","background: #fff",""].join(" !important;")),b.innerHTML="Page layout provided by &hearts; <a href=\"https://www.layouthub.com/?utm_source=client-site&utm_medium=footer&utm_campaign=freemium&utm_term=links&utm_content="+window.location.origin+"\">Layouthub.com</a>",a.appendChild(b)});